export const resolveInputType = (field, javaType, meta = {}) => {
  if (meta.hidden) return "hidden";
  if (meta.type) return meta.type;

  if (field.toLowerCase().includes("email")) return "email";
  if (field.toLowerCase().includes("phone")) return "tel";

  switch (javaType) {
    case "java.lang.Integer":
    case "java.lang.Long":
      return "number";
    case "java.lang.Boolean":
      return "checkbox";
    default:
      return "text";
  }
};
